import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../../core/services/admin.service';
import { SignalRService } from '../../../../../core/services/signal-r.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { IBroadcastMessage, IBroadcastMessageBody } from '../../../../../core/models';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { UserService } from '../../../../../core/services/user.service';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';

@Component({
  selector: 'app-broadcast-message-admin',
  templateUrl: './broadcast-message-admin.component.html',
  styleUrls: ['./broadcast-message-admin.component.scss']
})
export class BroadcastMessageAdminComponent implements OnInit {
  broadcastMessage: FormGroup;
  broadcastMessagingLoading: boolean;
  broadcastMessagingGridView: GridDataResult;
  broadcastMessages: IBroadcastMessage[];
  finalArray: any[] = [];
  constructor(private signalRService: SignalRService, private adminService: AdminService, private userService: UserService,
    private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService,

  ) { }

  ngOnInit() {   

    //#region - transform array
    //debugger;
    //var myArray: any[] = ['ABC', 'BCD', 'CDE', 'EFG', 'FGH', 'GHI', 'JKL', 'MNP', 'PQR', 'STD', 'EFG', 'HIJ', 'klo', 'pjd', 'ksd', 'kdk', 'dsd', 'skj', 'kds', 'ddd', 'jjss'];

    //var rowNumber = 5; //Change row number here
    //var coulmnNumber = ~~(myArray.length / rowNumber);
    //if (myArray.length % rowNumber > 0) {
    //  coulmnNumber = coulmnNumber + 1;
    //}
    //var i, j, k, l = 0, chunk = 4;
    ////for (i = 0, j = myArray.length; i < j; i += chunk) {
    ////  temparray = myArray.slice(i, i + chunk);
    ////  finalArray.push(temparray);
    ////  // do whatever
    ////}
    ////j = rowNumber,
    //for (k = 0; k < coulmnNumber; k++) {
    //  var temparray: any[] = [];
    //  for (i = k, j = myArray.length; i < j; i += rowNumber) {
    //    temparray.push(myArray[i]);

    //  }
    //  if (k == 0) {
    //    l = temparray.length;
    //  }
    //  else {
    //    if (temparray.length < l) {
    //      temparray.push("");
    //    }
    //  }
    //  this.finalArray.push(temparray);
    //}
    //#endregion

    this.broadcastMessage =  this.formBuilder.group({

      message: new FormControl(""),

    });
    this.loadBroadcastMessagingGrid();
  }
  broadcastMessageSubmit() {
    this.broadcastMessagingLbl.isSubmitted = true;
    if (!this.validateBroadcastMessageForm()) {
      return;
    }
    var controls = this.broadcastMessage.controls;
    const body: IBroadcastMessageBody = {

      message: controls.message.value,
      //messageAddedById: this.userService.readUserObject.userId,
      isActive: true
    }
    //this.adminService.broadcastMessage(controls.message.value);
    this.signalRService.startHttpRequest(controls.message.value);

    this.adminService.AddBroadcastMessage(body).subscribe((response: any) => {
      if (response) {
        this.loadBroadcastMessagingGrid();
      }
    });
  }
  broadcastMessageFromGrid(dataItem: IBroadcastMessage) {
    //debugger;
    this.signalRService.startHttpRequest(dataItem.message);
  }
  protected validateBroadcastMessageForm(): boolean {
    let isValid = true;
    const controls = this.broadcastMessage.controls;
    if (this.broadcastMessagingLbl.isSubmitted) {
      if (controls.message.value) {
        this.broadcastMessagingLbl.isEmptyMessage = false;
      } else {
        this.broadcastMessagingLbl.isEmptyMessage = true;
        isValid = false;
      }
    }
    return isValid;
  }
  broadcastMessagingLbl = {
    message: "Message",
    added: "Added By",
    addDate: "Added Date",
    isActive: "IsActive",
    action: "Action",
    isEmptyMessage: false,
    isSubmitted: false,
  }



  //#region Grid data binding
  private loadBroadcastMessagingGrid(): void {
    this.broadcastMessagingLoading = true;
    this.adminService.getBroadcastMessage().subscribe((response) => {
      this.broadcastMessages = response;
      this.bindBroadcastMessagingGrid();
      this.broadcastMessagingLoading = false;

    });
  }
  //#region pagination, sorting,filtering for grid

  public broadcastMessagingGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'MessageId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  //#endregion
  private bindBroadcastMessagingGrid(): void {

    this.broadcastMessagingGridView = process(this.broadcastMessages, this.broadcastMessagingGridstate);

  
  }

  protected broadcastMessagingGridSortChange(sort: SortDescriptor[]): void {
    this.broadcastMessagingGridstate.sort = sort;
    this.bindBroadcastMessagingGrid();
  }
  protected broadcastMessagingGridPageChange({ skip, take }: PageChangeEvent): void {
    this.broadcastMessagingGridstate.skip = skip;
    this.broadcastMessagingGridstate.take = take;
    this.bindBroadcastMessagingGrid();
  }

  public broadcastMessagingDataStateChange(state: DataStateChangeEvent): void {
    this.broadcastMessagingGridstate = state;
    this.bindBroadcastMessagingGrid();
  }
  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete broadcast message ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  protected RemoveHandler() {
    const messageId = this.gridItemToRemove.messageId;
    let body = {
      messageId: messageId
    }
    this.adminService.deleteBroadcastMessage(body).subscribe((isRemoved: boolean) => {      
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected broadcast message has been removed.");

      if (this.broadcastMessages) {
        //This is a Local Remove
        const index = (this.broadcastMessages).findIndex(r => r.messageId === messageId);
        (this.broadcastMessages).splice(index, 1);
        this.bindBroadcastMessagingGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
